<app-portfolio-item *ngFor="let item of items" [item]="item"></app-portfolio-item>